exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-name {\n  padding: 40px 0;\n  background: #f7f7f7; }\n  .profile-name h1 {\n    font-family: 'helveticaneuethin';\n    font-size: 24px;\n    color: #848484;\n    margin: 0;\n    line-height: 1; }\n    .profile-name h1 b {\n      font-family: 'helveticaneuethin'; }\n\n@media screen and (max-width: 595px) {\n  .profile-name {\n    padding: 30px 0; }\n    .profile-name h1 {\n      font-size: 18px; } }\n\n@media screen and (max-width: 480px) {\n  .profile-name h1 b {\n    display: block;\n    clear: both; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/welcome-profile/welcome-profile.component.scss
// module id = ../../../../../src/app/components/welcome-profile/welcome-profile.component.scss
// module chunks = main